<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <h3>Admin Site Settings</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 text-left" v-for="setting in store.state.settings" :key="setting.id">
                <div class="form-group">
                  <label>{{setting.friendlyName}}</label>
                  <select class="form-control" v-model="setting.val" v-if="setting.type == 'Select'">
                    <option value="Y">Y</option>
                    <option value="N">N</option>
                  </select>
                  <input class="form-control" v-model="setting.val" v-if="setting.type == 'Text'"/>
                </div>
              </div>
              <div class="col-sm-12">
                <button @click="updateSettings()" style="margin-bottom:20px" class="btn btn-primary btn-blue">Save Changes</button>
              </div>
            </div>

        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminSiteSettingsStore from './AdminSiteSettingsStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminSiteSettings',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminSiteSettingsStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      this.store.getSettings(data => {
        this.$forceUpdate();
      },err => {

      });
    },(err) => {
      this.nav.goAdminLogin(this)
    })
  },
  methods: {
    updateSettings(){
      this.store.state.settings.forEach(it => {
        this.store.updateSetting(it,data => {
          this.$toasted.show(`${it.friendlyName} updated!`, { type: 'success', duration: 2500 })
        }, err => {
          this.$toasted.show(err, { type: 'error', duration: 2500 })
        })
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminSiteSettings.vue